import {
    qry_user_ref,
    user_ref_set_notin,
    user_ref_upsert,
    UserRef,
    UserRefQryCond
} from "../db/t_user_ref";
import Context from "./context";
import UserController from "./user";
import {User, user_upsert} from "../db/t_user";
import {config_get, config_set} from "../db/t_config";
import time from "../time";
import log from "../log";

export default class ContactController {
    private static lastRefreshTime: number = 0; // 上一次更新时间
    private static isRefreshing: boolean = false; // 是否正在刷新
    public static Clear() {
        ContactController.lastRefreshTime = 0;
        ContactController.isRefreshing = false;
    }

    // 获取通讯录列表
    public static async Get(
        ctx: Context,
        cond: UserRefQryCond
    ): Promise<{ error: any; refs?: UserRef[]; users?: User[] }> {
        const r0 = await qry_user_ref(ctx.db, cond);
        if (r0.error) {
            return {error: r0.error};
        }
        if (!(r0.data && r0.data.length > 0)) {
            // 检查本地上一次是什么时候更新的数据，超过一定时间强制刷新
            ContactController.check_and_refresh(ctx).then(() => {
            });
            return {error: null};
        }

        const uids = r0.data.map((v) => v.uid);
        const r1 = await UserController.GetMuti(ctx, uids, true);
        if (r1.error) {
            return {error: r1.error};
        }

        // 检查本地上一次是什么时候更新的数据，超过一定时间强制刷新
        ContactController.check_and_refresh(ctx).then(() => {
        });

        // 返回
        return {error: null, refs: r0.data, users: r1.users};
    }

    public static async GetRemote(ctx: Context) {
        console.log('🔄 [ContactController] GetRemote 被调用');
        const result = await this.refresh_friend(ctx);
        console.log('✅ [ContactController] GetRemote 返回, error:', result.error, 'users count:', result.users?.length || 0);
        return result;
    }

    // 检查本地上一次是什么时候更新的数据，超过一定时间强制刷新
    private static async check_and_refresh(ctx: Context) {
        if (ContactController.isRefreshing) {
            log.debug("通讯录刷新中忽略本次");
            return;
        }
        const db_key = "contact_refresh_time";
        if (ContactController.lastRefreshTime === 0) {
            // 从数据库里load数据
            const r0 = await config_get(ctx.db, db_key);
            if (r0.data && r0.data.val) {
                log.info("从数据库获取通讯录更新时间", r0.data.val);
                ContactController.lastRefreshTime = parseInt(r0.data.val, 10);
            }
        }
        // 检查没过期不用刷新
        const exp = time.toUnixMillSecond(time.add(time.now(), -1 * time.DAY));
        if (ContactController.lastRefreshTime > exp) {
            const dateStr = time.formatDate(
                time.fromUnixMillSecond(ContactController.lastRefreshTime)
            );
            log.debug("上一次更新通讯录更新时间", dateStr, "忽略本次");
            return;
        }

        // 二次检查
        if (ContactController.isRefreshing) {
            return;
        }

        {
            const t1 = time.formatDate(
                time.fromUnixMillSecond(ContactController.lastRefreshTime)
            );
            const t2 = time.formatDate(time.fromUnixMillSecond(exp));
            log.info("检查通讯录刷新时间，上一次", t1, "过期时间", t2);
        }

        ContactController.isRefreshing = true;
        // 更新
        const r1 = await ContactController.refresh(ctx);
        if (r1.error) {
            ContactController.isRefreshing = false;
            return;
        }
        // 保存更新时间

        ContactController.lastRefreshTime = time.toUnixMillSecond(time.now());
        await config_set(
            ctx.db,
            db_key,
            ContactController.lastRefreshTime.toString(10)
        );
        ContactController.isRefreshing = false;
        log.info("通讯录刷新更新完成", ContactController.lastRefreshTime);
        // 事件通知，让通讯录页面自动刷新
        ctx.mq.emit_stash("contact_refresh", {});
    }


    private static async refresh(ctx: Context): Promise<{ error: any }> {
        console.log('🔄 [ContactController] refresh 开始刷新联系人');
        const errors: any[] = [];
        const r1 = await ContactController.refresh_friend(ctx);
        console.log('✅ [ContactController] refresh_friend 完成, error:', r1.error, 'users count:', r1.users?.length || 0);
        if (r1.error) {
            errors.push(r1.error);
        }
        return {error: errors.length > 0 ? errors : null};
    }

    // 更新好友
    private static async refresh_friend(ctx: Context): Promise<{ error: any, users?: User[] }> {
        console.log('🔄 [ContactController] refresh_friend 开始从服务器获取联系人列表');
        const r0 = await ctx.conn.Call("/v1/sdk/friend/list", {});
        console.log('✅ [ContactController] /v1/sdk/friend/list 返回, code:', r0?.code, 'users count:', r0?.data?.users?.length || 0);

        if (!(r0 && r0.code === 0)) {
            return {error: JSON.stringify(r0)};
        }
        // users为空也要处理，说明要删除一些数据
        const users = r0.data && r0.data.users ? (r0.data.users as User[]) : [];
        const allFriendUids: number[] = users.map((v) => v.uid);
        await user_ref_set_notin(ctx.db, allFriendUids, "friend");
        const n = users.length;
        const myplat = ctx.appkey.length > 0 ? ctx.appkey.charAt(0) : "";
        const allChainUids: number[] = [];
        for (let i = 0; i < n; i++) {
            await user_upsert(ctx.db, users[i]);
            const plat =
                users[i].appkey.length > 0 ? users[i].appkey.charAt(0) : "";
            const ischain =
                myplat !== "" && plat !== "" && myplat !== plat ? 1 : 0;
            if (ischain) {
                allChainUids.push(users[i].uid);
            }
            await user_ref_upsert(
                ctx.db,
                {
                    uid: users[i].uid,
                    isfriend: 1,
                    isstaff: 0,
                    ischain: ischain,
                    plat: "",
                    appkey: users[i].appkey,
                    main_appkey: users[i].mainAppkey,
                    lutime: 0,
                    lctime: 0
                },
                ["friend", "chain"]
            );
        }
        await user_ref_set_notin(ctx.db, allChainUids, "chain");
        return {error: null, users: users};
    }

}
